import * as uuid from "uuid";

import EventManager from "../../store/sqftEventManager";
import {SHAPE_PART_ID, SIDEBAR_BUTTONS_MENU} from "../../../../constants";
import COLOR_THEMES from "../../../../../../colorThemes";
import eventManager from "../../store/sqftEventManager";
import store from "../../../../../../store";
import workspaceControllers from "../../store/workspaceControllers";
import {
  getDistanceFromPointToLine,
  getMousePositionOnShape,
  getParallelPoints,
  getPointField
} from "../../../../helpers/sqftHelper";
import sqftEventManager from "../../store/sqftEventManager";
import {
  adjustPointsRelativeToTopLeft,
  findTopLeftPoint, getPointsCoords,
  getThePositionOfAPointToTheLeftOrRightOfALine, sortPointsClockwise
} from "../../../../helpers/coordinatesHelper";
import sqftConfig from "../../store/sqftConfig";
import {createShapeFromPoints} from "../../../../helpers/freeDrawHelper";
import sqftShapeManager from "../../store/sqftShapeManager";
import ShapeCabinet from "./shapeParts/shapeCabinet";
import {getSpacerDbFeature} from "../../../../helpers/featureHelper";
import cabinetWorkspace from "../cabinet/cabinetWorkspace";
import {getCabinetDimensions} from "../../../../helpers/sqft3dArHelper";
import {getCurrentLayout} from "../../../../../appLayout";

export default class Spacer {
  id;
  state = {
    centerPoint: {x: 0, y: 0},
    betweenPoints: [],
    isCreated: false,
    isHovering: false,
    mouseDown: false,
    mouseDownPosition: null,
  };

  constructor(points, centerPoint) {
    this.id = uuid.v4();
    this.state.betweenPoints = points
    this.state.centerPoint = centerPoint
    this.initEvents();
  }

  getIsCreated() { return this.state.isCreated }
  setCreated(value) { this.state.isCreated = value}

  initEvents() {
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render.bind(this),
      this,
      EventManager.priorities.WALL
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      this.onMouseDown.bind(this),
      this,
      EventManager.priorities.OVERALL
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      this.onMouseMove.bind(this),
      this,
      EventManager.priorities.SEGMENT
    );
  }

  destroy() {
    this.deregisterEvents();
    this.destroyPoints();
  }

  destroyPoints() {
    for (const addedPoints of this.state.betweenPoints) {
      addedPoints.destroy()
    }
  }

  deregisterEvents() {
    eventManager.removeEvent(this);
  }

  onMouseDown(mousePos) {
    void mousePos;
    if (this.state.isHovering) {
      const reduxState = store.getState();
      if (reduxState.sqftMenuState.activeButton === SIDEBAR_BUTTONS_MENU.delete) {
        workspaceControllers.spacer.destroyResource(this)
        return true
      }
    }

    if (!this.state.isCreated) {
      this.createShapeFromSpacerPoints()
      this.setCreated(true);
      workspaceControllers.spacer.destroyResource(this);
      workspaceControllers.spacer.setIsJustCreated(true);
      return true
    }

    return false
  }

  createShapeFromSpacerPoints = () => {
    const [point3, point4] = this.getPointsToTheMouse();
    const shape = this.state.betweenPoints[0].getParent().getParent();

    // Получаем позиции точек на шейпе
    const point3PointField = getMousePositionOnShape(point3.x, point3.y, shape);
    const point4PointField = getMousePositionOnShape(point4.x, point4.y, shape);

    // Собираем точки шейпа
    const shapePoints = [
      this.state.betweenPoints[1],
      point3PointField,
      point4PointField,
      this.state.betweenPoints[0]
    ];

    const topLeftPoint = findTopLeftPoint(shapePoints);
    const adjustedShapePoints = adjustPointsRelativeToTopLeft(shapePoints, topLeftPoint);
    const sortedPoints = sortPointsClockwise(adjustedShapePoints);
    if (!sortedPoints) {
      console.warn("Shape creation skipped due to undefined points.");
      return;
    }

    const shapePosition = shape.getPosition();
    const newShapePosition = {
      x: topLeftPoint.x + shapePosition.x,
      y: topLeftPoint.y + shapePosition.y
    };

    const shapeParams = {
      ...shape.shapeParams,
      isSpacer: true,
      canSnap: true,
    };

    const spacerShapeId = createShapeFromPoints(sortedPoints, SHAPE_PART_ID.spacer,
      false,
      newShapePosition,
      false,
      null,
      shapeParams
    );

    const spacerShape = sqftShapeManager.getShapeById(spacerShapeId);
    spacerShape.featureId = shape.featureId;
    const layout = getCurrentLayout();
    const shapeFeature = layout.getFeatureById(shape.featureId, true);
    const parentFeature = layout.getFeatureById(shape.relatedParentFeatureId, true);
    const spacerDbFeature = getSpacerDbFeature(shapeFeature, parentFeature);
    if (spacerDbFeature) {
      spacerShape.featureId = spacerDbFeature.id;
      const spacerFeature = layout.getFeatureById(spacerDbFeature.id, true);
      const dimensions = getCabinetDimensions(spacerFeature, parentFeature);
      const spacerLayout = cabinetWorkspace.cabinetShapes.getShapeLayout(spacerFeature, parentFeature)
      const lines = cabinetWorkspace.cabinetShapes.getShapeLines(spacerLayout, dimensions);
      const spacerOriginalPointCords = getPointsCoords(lines);
      spacerShape.setOriginalPointsCoords(spacerOriginalPointCords);
    }

    spacerShape.relatedParentFeatureId = shape.relatedParentFeatureId;
    spacerShape.parentPartId = shape.partId;
    spacerShape.featureName = shape.featureName;
    spacerShape.colorSet = shape.colorSet;
    if (shape.shapeCabinet) {
      spacerShape.shapeCabinet = new ShapeCabinet(spacerShape)
    }
  }

  onMouseMove(mousePos) {
    void mousePos
    //this.state.isHovering = this.isMouseOverWall(mousePos) || this.state.mouseDown;
  }

  render(ctx) {
    if (this.state.isCreated) {
      //this.renderLines(ctx);
    } else {
      this.renderLinesToMouse(ctx);
    }
  }

  getPointsToTheMouse() {
    const betweenPoint1 = this.state.betweenPoints[0];
    const betweenPoint2 = this.state.betweenPoints[1];
    let pointField1 = getPointField(betweenPoint1.x, betweenPoint1.y, betweenPoint1.getParent().getParent());
    let pointField2 = getPointField(betweenPoint2.x, betweenPoint2.y, betweenPoint1.getParent().getParent());
    let mousePos = sqftEventManager.LastKnownMousePos;
    const distanceFromMouseToTheLine = getDistanceFromPointToLine(
      mousePos.x,
      mousePos.y,
      pointField1.x,
      pointField1.y,
      pointField2.x,
      pointField2.y,
    )
    const pointLeftRightPosition = getThePositionOfAPointToTheLeftOrRightOfALine(pointField1, pointField2, mousePos);
    const parallelPoints = getParallelPoints(
      pointField1,
      pointField2,
      pointLeftRightPosition > 0
        ? -distanceFromMouseToTheLine
        : distanceFromMouseToTheLine
    );
    void parallelPoints;
    // console.log("pointField1", pointField1);
    // console.log("pointField2", pointField2);
    // console.log("distanceFromMouseToTheLine", distanceFromMouseToTheLine);
    // console.log("mousePos", mousePos);
    // console.log("parallelPoints0", parallelPoints[0]);
    // console.log("parallelPoints1", parallelPoints[1]);
    // console.log("pointLeftRightPosition", pointLeftRightPosition);
    return parallelPoints
  }

  renderLinesToMouse(ctx) {
    const [point3, point4] = this.getPointsToTheMouse();
    ctx.lineWidth = this.state.lineWidth;
    ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].primary;
    ctx.strokeStyle = this.state.lineColor;

    const betweenPoint1 = this.state.betweenPoints[0];
    const betweenPoint2 = this.state.betweenPoints[1];
    let pointField1 = getPointField(betweenPoint1.x, betweenPoint1.y, betweenPoint1.getParent().getParent());
    let pointField2 = getPointField(betweenPoint2.x, betweenPoint2.y, betweenPoint1.getParent().getParent());
    ctx.beginPath()
    ctx.moveTo(pointField1.x, pointField1.y);
    ctx.lineTo(pointField2.x, pointField2.y);
    ctx.lineTo(point3.x, point3.y);
    ctx.lineTo(point4.x, point4.y);
    ctx.fill();
    ctx.closePath();
    ctx.stroke();
  }

  // renderLines(ctx) {
  //   const reduxState = store.getState();
  //   const activeButton = reduxState.sqftMenuState.activeButton;
  //   ctx.lineWidth = this.state.lineWidth;
  //   ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].primary;
  //   ctx.strokeStyle = this.state.isHovering && activeButton === SIDEBAR_BUTTONS_MENU.delete
  //     ? COLORS.red
  //     : this.state.lineColor;
  //
  //   const betweenPoint1 = this.state.betweenPoints[0];
  //   const betweenPoint2 = this.state.betweenPoints[1];
  //   const betweenPoint3 = this.state.betweenPoints[3];
  //   const betweenPoint4 = this.state.betweenPoints[4];
  //   let pointField1 = getPointField(betweenPoint1.x, betweenPoint1.y, betweenPoint1.getParent().getParent());
  //   let pointField2 = getPointField(betweenPoint2.x, betweenPoint2.y, betweenPoint1.getParent().getParent());
  //   let pointField3 = getPointField(betweenPoint3.x, betweenPoint3.y, betweenPoint1.getParent().getParent());
  //   let pointField4 = getPointField(betweenPoint4.x, betweenPoint4.y, betweenPoint1.getParent().getParent());
  //
  //   ctx.beginPath()
  //   ctx.moveTo(pointField1.x, pointField1.y);
  //   ctx.lineTo(pointField2.x, pointField2.y);
  //   ctx.lineTo(pointField3.x, pointField3.y);
  //   ctx.lineTo(pointField4.x, pointField4.y);
  //   ctx.fill();
  //   ctx.closePath();
  //   ctx.stroke();
  // }
}
